var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.$store.getters['global/isEmojiPickerShown'] )?_c('VEmojiPicker',{attrs:{"labelSearch":_vm.$t('room.pick_your_emoji')},on:{"select":_vm.addEmoji}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }